/**
 * Use this to enable exhaustive enum switch statement checks at compile-time.
 *
 * Usage:
 * In the default (last) case, write unhandledEnum(myEnum), where myEnum is the enum value in the switch statement.
 *
 * If your switch statement is not exhaustively handled, you will receive a compiler error:
 * Type "MyEnum.myEnum" is not assignable to type "never". Thus indicating you that MyEnum.myEnum is not handled yet.
 *
 * @param x an enum expression
 */
const unhandledEnum = (x: never): never => {
  throw new Error(`Unreachable statement! ${x}`);
};

export { unhandledEnum };
